import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/button';
import { XCircle, RefreshCw, Home } from 'lucide-react';

export default function DepositCancel() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#0A0E14] flex items-center justify-center p-4 relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-slate-500/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-lg w-full relative z-10">
        <div className="text-center mb-8">
          <div className="w-28 h-28 rounded-full bg-gradient-to-br from-amber-500/20 to-amber-500/5 flex items-center justify-center mx-auto mb-6 border-2 border-amber-500/30">
            <XCircle className="w-14 h-14 text-amber-400" />
          </div>
        </div>

        <div className="glass-card p-8 text-center border border-amber-500/20 rounded-3xl bg-gradient-to-b from-amber-500/5 to-transparent backdrop-blur-xl">
          <h1 className="text-3xl font-bold text-white mb-2 font-['Outfit']">
            {t('paymentPages.paymentCancelled')}
          </h1>
          <p className="text-slate-400 mb-6">
            {t('paymentPages.cardPaymentCancelled')}<br />
            {t('paymentPages.noChargesMade')}
          </p>
          
          <div className="bg-slate-500/10 border border-slate-500/20 rounded-2xl p-4 mb-6">
            <p className="text-slate-300 text-sm">
              {t('paymentPages.canRetryAnytime')}
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate('/deposit')}
              className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-xl h-12 px-6 font-semibold shadow-lg shadow-blue-500/25 transition-all hover:scale-105"
              data-testid="try-again-btn"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              {t('paymentPages.tryAgain')}
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="bg-white/5 hover:bg-white/10 border-white/10 text-white rounded-xl h-12 px-6"
              data-testid="back-to-dashboard-btn"
            >
              <Home className="w-4 h-4 mr-2" />
              {t('paymentPages.backToDashboard')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
